import type { ParsedUrlQuery } from 'querystring';

export interface MemberBannerPreviewConfig {
  variant: 'annual' | 'lifetime' | 'off';
  layout: 'current' | 'fit';
  percentOff: 20 | 30 | 40;
  duration: 'once' | 'forever' | 'repeating';
  lifetimePriceCents: 100000 | 125000;
}

/** Presentation fixtures only. Deployed staging builds use NODE_ENV=production too. */
export const readMemberBannerPreview = (
  query: ParsedUrlQuery,
  stage = process.env.APP_STAGE,
  native = process.env.TARGET_PLATFORM === 'MOBILE',
): MemberBannerPreviewConfig | null => {
  if (stage !== 'development' || native) return null;
  const {
    memberBanner,
    memberBannerLayout,
    memberBannerDiscount,
    memberBannerDuration,
    memberBannerPrice,
  } = query;
  if (
    !['annual', 'lifetime', 'off'].includes(String(memberBanner)) ||
    typeof memberBanner !== 'string' ||
    (memberBannerLayout !== undefined &&
      !['current', 'fit'].includes(String(memberBannerLayout))) ||
    (memberBannerDiscount !== undefined &&
      !['20', '30', '40'].includes(String(memberBannerDiscount))) ||
    (memberBannerDuration !== undefined &&
      !['once', 'forever', 'repeating'].includes(String(memberBannerDuration))) ||
    (memberBannerPrice !== undefined && !['1000', '1250'].includes(String(memberBannerPrice))) ||
    [memberBannerLayout, memberBannerDiscount, memberBannerDuration, memberBannerPrice].some(
      Array.isArray,
    )
  )
    return null;
  return {
    variant: memberBanner as MemberBannerPreviewConfig['variant'],
    layout: memberBannerLayout === 'current' ? 'current' : 'fit',
    percentOff: Number(memberBannerDiscount || 40) as MemberBannerPreviewConfig['percentOff'],
    duration: (memberBannerDuration || 'forever') as MemberBannerPreviewConfig['duration'],
    lifetimePriceCents: memberBannerPrice === '1250' ? 125000 : 100000,
  };
};
